import { CheckmarkOutline, Close } from "@carbon/icons-react";
import React from "react";
import { ToastContentProps } from "react-toastify";

export const SuccessToast = ({ closeToast, data }: ToastContentProps<{ text: string }>) => {
  return (
    <div className="bg-green-700 text-white flex items-center justify-between py-3 px-4 w-[400px] rounded shadow-toast-success">
      <div className="flex items-center gap-3">
        <CheckmarkOutline className="text-green-300" size={20} />
        <p className="text-[18px] leading-[22.68px]">{data?.text}</p>
      </div>
      <button onClick={closeToast}>
        <Close className="text-green-300" size={20} />
      </button>
    </div>
  );
};
